// eslint-disable-next-line import/no-self-import
import mitt from 'mitt';

export const emitter = mitt();
